// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const koraidon: PokeData = {
  "id": 1007,
  "name": "koraidon",
  "height": 25,
  "weight": 3030,
  "base_experience": 335,
  "types": [
    PokeType.FIGHTING,
    PokeType.DRAGON
  ],
  "api_moves": [
    "flamethrower",
    "counter",
    "agility",
    "screech",
    "outrage",
    "sunny-day",
    "ancient-power",
    "rock-smash",
    "brick-break",
    "dragon-claw",
    "close-combat",
    "flare-blitz",
    "drain-punch",
    "giga-impact",
    "breaking-swipe",
    "collision-course"
  ],
  "moves": [
    "flamethrower",
    "outrage",
    "sunny-day",
    "ancient-power",
    "rock-smash",
    "dragon-claw",
    "close-combat",
    "flare-blitz",
    "drain-punch",
    "dragon-vortex",
    "jump-kick",
    "rolling-kick",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 535,
    "item": null,
    "species": [
      {
        "name": "koraidon",
        "order": 998,
        "types": [
          PokeType.FIGHTING,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 144,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
